import React, { useState } from 'react';

//Components
import { OutlinedInput as MuiOutlinedInput } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';

//CSS & Icons
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';

const OutlinedTextField = props => {
  const { classes, tooltip, isPassword, ...otherProps } = props;

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  if (!isPassword) {
    return <MuiOutlinedInput />;
  }
  return (
    <MuiOutlinedInput
      classes={classes}
      type={showPassword ? 'text' : 'password'}
      endAdornment={
        <InputAdornment position='end'>
          <IconButton aria-label='toggle password visibility' onClick={handleClickShowPassword} edge='end'>
            {!showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      }
      {...otherProps}
    />
  );
};

export { OutlinedTextField };
